import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './shared/auth/guards/auth.guard';
import { LandingPageComponent } from './shared/landing-page/landing-page.component';
import { NgModule } from '@angular/core';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
import { appPaths } from './rpfsa.route.paths';
import { customersPaths } from './customers/customers.routes';
import { dwrsPaths } from './daily-work-reports/daily-work-reports.routes';
import { fieldTeamsPaths } from './field-teams/field-teams.routes';
import { flashAuditsPaths } from './flash-audits/flash-audits.routes';
import { invoicingPaths } from './invoicing/invoicing.routes';
import { jobsPaths } from './jobs/jobs.routes';
import { jsfsPaths } from './job-setup-forms/job-setup.forms.routes';
import { payrollPaths } from './payroll/payroll.routes.module';
import { personnelPaths } from './personnel/personnel.routes';
import { quotesPaths } from './quotes/quotes.routes';
import { railroadsPaths } from './railroads/railroads.routes';
import { usersPaths } from './users/users.routes';
import { utilityFormsPaths } from './utility-forms/utility-forms.routes';
import { settingsPaths } from './settings/settings.routes';
import { DefaultRouteGuard } from './shared/auth/guards/default-route.guard';

const routes: Routes = [
	{
		path: appPaths.default,
		component: LandingPageComponent,
		canActivate: [
			AuthGuard,
			DefaultRouteGuard
		],
		pathMatch: 'full',
	},
	{
		path: usersPaths.root,
		pathMatch: 'prefix',
		loadChildren: () =>
			import('../admin-app/users/users.module').then(
				(m) => m.UsersModule
			),
	},
	{
		path: customersPaths.root,
		pathMatch: 'prefix',
		loadChildren: () =>
			import('../admin-app/customers/customers.module').then(
				(m) => m.CustomersModule
			),
	},
	{
		path: quotesPaths.root,
		pathMatch: 'prefix',
		loadChildren: () =>
			import('../admin-app/quotes/quotes.module').then(
				(m) => m.QuotesModule
			),
		canActivate: [AuthGuard],
	},
	{
		path: payrollPaths.root,
		pathMatch: 'prefix',
		loadChildren: () =>
			import('../admin-app/payroll/payroll.module').then(
				(m) => m.PayrollModule
			),
		canActivate: [AuthGuard],
	},
	{
		path: invoicingPaths.root,
		pathMatch: 'prefix',
		loadChildren: () =>
			import('../admin-app/invoicing/invoicing.module').then(
				(m) => m.InvoicingModule
			),
		canActivate: [AuthGuard],
	},
	{
		path: utilityFormsPaths.root,
		pathMatch: 'prefix',
		loadChildren: () =>
			import('../admin-app/utility-forms/utility-forms.module').then(
				(m) => m.UtilityFormsModule
			),
		canActivate: [AuthGuard],
	},
	{
		path: railroadsPaths.root,
		pathMatch: 'prefix',
		loadChildren: () =>
			import('../admin-app/railroads/railroads.module').then(
				(m) => m.RailroadsModule
			),
	},
	{
		path: personnelPaths.root,
		pathMatch: 'prefix',
		loadChildren: () =>
			import('../admin-app/personnel/personnel.module').then(
				(m) => m.PersonnelModule
			),
	},
	{
		path: fieldTeamsPaths.root,
		pathMatch: 'prefix',
		loadChildren: () =>
			import('../admin-app/field-teams/field-teams.module').then(
				(m) => m.FieldTeamsModule
			),
	},
	{
		path: jobsPaths.root,
		pathMatch: 'prefix',
		loadChildren: () =>
			import('../admin-app/jobs/jobs.module').then((m) => m.JobsModule),
	},
	{
		path: dwrsPaths.root,
		pathMatch: 'prefix',
		loadChildren: () =>
			import(
				'../admin-app/daily-work-reports/daily-work-reports.module'
			).then((m) => m.DailyWorkReportsModule),
	},
	{
		path: jsfsPaths.root,
		pathMatch: 'prefix',
		loadChildren: () =>
			import('../admin-app/job-setup-forms/job-setup-forms.module').then(
				(m) => m.JobSetupFormsModule
			),
	},
	{
		path: flashAuditsPaths.root,
		pathMatch: 'prefix',
		loadChildren: () =>
			import('../admin-app/flash-audits/flash-audits.module').then(
				(m) => m.FlashAuditsModule
			),
	},
	{
		path: settingsPaths.root,
		pathMatch: 'prefix',
		loadChildren: () =>
			import('../admin-app/settings/settings.module').then(
				(m) => m.SettingsModule
			),
		canActivate: [AuthGuard],
	},
	{
		path: appPaths.notFound,
		pathMatch: 'prefix',
		component: PageNotFoundComponent,
	},
	{
		path: appPaths.notAuthorized,
		pathMatch: 'prefix',
		component: PageNotFoundComponent,
	},
	{
		path: appPaths.otherwise,
		pathMatch: 'prefix',
		component: PageNotFoundComponent,
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			preloadingStrategy: PreloadAllModules,
			onSameUrlNavigation: 'reload',
			relativeLinkResolution: 'legacy',
			useHash: false
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule { }
